<template>
  <v-container>
    <mensajeSistema />

    <v-row justify="center">
      <v-col cols="12" v-if="alumnosVacacional.length !== 0 && !loading">
        <v-expansion-panels accordion focusable>
          <!-- multiple -->
          <v-expansion-panel
            v-for="itemParent in alumnosVacacional"
            :key="itemParent.id_grado_adm"
          >
            <v-expansion-panel-header class="px-2 pa-0">
              <v-row no-gutters class="d-flex">
                <v-col cols="4" align-self="center">
                  <v-avatar size="36px">
                    <img
                      alt="Avatar"
                      src="https://previews.123rf.com/images/glopphy/glopphy1412/glopphy141200007/34198231-ilustraci%C3%B3n-libro-icono-de-dise%C3%B1o-de-la-plantilla-vector-logo.jpg"
                    />
                  </v-avatar>
                  <b> {{ itemParent.desc_grado }} </b>
                </v-col>

                <v-col cols="8" class="text--secondary customrow">
                  <v-fade-transition leave-absolute>
                    <v-row
                      justify="space-around"
                      no-gutters
                      style="width: 100%"
                    >
                      <v-col cols="6" align-self="center">
                        Niveles: {{ itemParent.desc_nivel }}
                      </v-col>

                      <v-col @click.stop cols="auto" align-self="center">
                        <v-select
                          :items="itemsDocente"
                          small-chips
                          dense
                          item-value="id_personal"
                          item-text="nombre_apellido"
                          label="Asignar docente"
                        ></v-select>
                      </v-col>
                    </v-row>
                  </v-fade-transition>
                </v-col>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <br />
              <v-expansion-panels
                v-model="panelAlumnosNotas"
                v-show="showDetalle"
                accordion
                focusable
              >
                <v-expansion-panel
                  v-for="itemAlumnos in itemParent.grados_estudiante"
                  :key="itemAlumnos.id_alumno"
                >
                  <v-expansion-panel-header
                    class="px-2 pa-0"
                    color="blue lighten-5"
                  >
                    <v-row no-gutters>
                      <v-col cols="4">
                        <v-avatar size="36px">
                          <img
                            alt="Avatar"
                            src="https://static.vecteezy.com/system/resources/previews/038/042/984/non_2x/graduate-student-avatar-icon-in-colors-vector.jpg"
                          />
                        </v-avatar>
                        <b>{{ itemAlumnos.nombres_completos }} </b>
                        <small style="color: red">
                          {{
                            !itemAlumnos.estado_alumno
                              ? "(Alumno Evaluado)"
                              : ""
                          }}</small
                        >
                      </v-col>
                      <v-col cols="8" class="text--secondary customrow">
                        <v-fade-transition leave-absolute>
                          <v-row
                            justify="space-around"
                            no-gutters
                            style="width: 100%"
                          >
                            <v-col cols="6">
                              Grado: {{ itemAlumnos.desc_grado }}
                            </v-col>
                            <v-col cols="auto">
                              Situacion final:
                              <v-chip
                                class="text-uppercase"
                                label
                                :class="
                                  itemAlumnos.criterio_estado_final ==
                                  'PROMOVIDO'
                                    ? 'color_aprobado'
                                    : itemAlumnos.criterio_estado_final ==
                                      'PERMANENCIA'
                                    ? 'color_desaprobado'
                                    : itemAlumnos.criterio_estado_final ==
                                      'RECUPERACIÓN PEDAGÓGICA'
                                    ? 'color_recuperacion'
                                    : ''
                                "
                                small
                              >
                                {{ itemAlumnos.criterio_estado_final }}
                              </v-chip>
                            </v-col>
                          </v-row>
                        </v-fade-transition>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content active-class class="expaco">
                    <v-overlay
                      :value="!itemAlumnos.estado_alumno"
                      absolute
                      color="white"
                      opacity="0.5"
                    ></v-overlay>
                    <v-container>
                      <v-row>
                        <v-col cols="auto">
                          <small class="text-caption customheight">
                            DETALLES DE LAS AREAS EVALUADAS:
                          </small>
                        </v-col>

                        <v-col
                          cols="auto"
                          class=""
                          v-for="norma in obtenerCondicionNormativa(
                            itemAlumnos.id_alumno,
                            itemAlumnos.id_grado_clickone,
                            itemAlumnos.id_nivel_clickone
                          )"
                          :key="norma.id_condicion"
                        >
                          <v-menu
                            attach
                            offset-y
                            :content-props="itemAlumnos"
                            max-width="30%"
                            allow-overflow
                            content-class="classMenu"
                            rounded
                            v-model="norma.show_alumno"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                dark
                                elevation="2"
                                :color="norma.color"
                                small
                                @click="openTooltipNorma(norma)"
                              >
                                <v-icon left dark> fas fa-eye </v-icon>
                                {{ norma.tipo_condicion_desc }}
                              </v-btn>
                            </template>
                            <v-alert
                              class="ma-0"
                              icon="mdi-information-outline"
                              dense
                              outlined
                              border="left"
                              text
                              :type="
                                norma.id_tipos_promocion == 1
                                  ? 'success'
                                  : norma.id_tipos_promocion == 2
                                  ? 'error'
                                  : 'warning'
                              "
                            >
                              <div
                                class="enunciadoAlert"
                                v-html="norma.descripcion_condicion"
                              ></div>
                            </v-alert>
                          </v-menu>
                        </v-col>
                        <v-col cols="6">
                          <v-data-table
                            @sorted="dragToTable"
                            v-sortable
                            :ref="'dataTable' + itemAlumnos.id_alumno"
                            dense
                            :items="itemAlumnos.areas_estudiante"
                            item-value="name"
                            class="elevation-1"
                            hide-default-header
                            hide-default-footer
                          >
                            <template v-slot:header>
                              <thead>
                                <tr style="background-color: #efefef">
                                  <th rowspan="2" class="text-center">Area</th>
                                  <th colspan="5" class="text-center">
                                    Calificaciones del Estudiante
                                  </th>
                                  <th rowspan="2" class="text-center">
                                    Condicion del Estudiante
                                  </th>
                                </tr>
                                <tr style="background-color: #efefef">
                                  <th class="text-center">C1</th>
                                  <th class="text-center">C2</th>
                                  <th class="text-center">C3</th>
                                  <th class="text-center">C4</th>
                                  <th class="text-center">C5</th>
                                </tr>
                              </thead>
                            </template>

                            <template v-slot:body="{ items }">
                              <tbody>
                                <tr
                                  v-for="areas in items"
                                  :key="areas.id_area_adm"
                                >
                                  <td class="text-center">
                                    {{ areas.desc_area }}
                                  </td>
                                  <td
                                    v-for="index in 5"
                                    :key="index"
                                    class="text-center tdrecuperacion"
                                  >
                                    <v-tooltip top color="#1b1b1b">
                                      <template
                                        v-slot:activator="{ on, attrs }"
                                      >
                                        <v-badge
                                          bordered
                                          color="success"
                                          :value="
                                            validaSeleccion(
                                              itemAlumnos.competencias_recuperar,
                                              areas.nivel_logro_competencias_area,
                                              index
                                            )
                                          "
                                          icon="mdi-check"
                                          overlap
                                        >
                                          <v-btn
                                            class="draggable-button"
                                            @click="
                                              addRowNotaComp(
                                                areas.desc_area,
                                                itemAlumnos,
                                                areas
                                                  .nivel_logro_competencias_area[
                                                  index - 1
                                                ]
                                              )
                                            "
                                            small
                                            :style="
                                              obtenerEstilosParaNotas(
                                                obtenerNotaComp(
                                                  itemAlumnos.competencias_recuperar,
                                                  areas.nivel_logro_competencias_area,
                                                  index
                                                )
                                              )
                                            "
                                            :disabled="
                                              desabilitarBotonesNotas(
                                                obtenerNotaComp(
                                                  itemAlumnos.competencias_recuperar,
                                                  areas.nivel_logro_competencias_area,
                                                  index
                                                )
                                              )
                                            "
                                            :class="
                                              validaSeleccion(
                                                itemAlumnos.competencias_recuperar,
                                                areas.nivel_logro_competencias_area,
                                                index
                                              )
                                                ? 'animate__animated animate__pulse animate__infinite infinite'
                                                : ''
                                            "
                                            v-on="on"
                                            v-bind="attrs"
                                          >
                                            {{
                                              convertirNumAliteral(
                                                obtenerNotaComp(
                                                  itemAlumnos.competencias_recuperar,
                                                  areas.nivel_logro_competencias_area,
                                                  index
                                                )
                                              )
                                            }}
                                          </v-btn>
                                        </v-badge>
                                      </template>
                                      <span>
                                        {{
                                          obtenerDesComp(
                                            areas.nivel_logro_competencias_area[
                                              index - 1
                                            ]
                                          )
                                        }}
                                      </span>
                                    </v-tooltip>
                                  </td>
                                  <td class="text-center" style="width: 250px">
                                    <b
                                      :style="{
                                        color:
                                          areas.criterio_area_condicion ==
                                          'PROMOVIDO'
                                            ? '#4caf50'
                                            : areas.criterio_area_condicion ==
                                              'PERMANENCIA'
                                            ? '#e53935'
                                            : areas.criterio_area_condicion ==
                                              'RECUPERACIÓN PEDAGÓGICA'
                                            ? '#bd8d06'
                                            : '',
                                      }"
                                      >{{ areas.criterio_area_condicion }}</b
                                    >
                                  </td>
                                </tr>
                              </tbody>
                            </template>
                          </v-data-table>
                        </v-col>
                        <v-col cols="6">
                          <v-simple-table fixed-header>
                            <template v-slot:default>
                              <thead style="background-color: #efefef">
                                <tr>
                                  <th
                                    v-for="(head, idx) in headerSelectorComp"
                                    :style="{
                                      'background-color': '#efefef',
                                      width:
                                        idx == 0
                                          ? '50%'
                                          : idx == 1
                                          ? '25%'
                                          : idx == 2
                                          ? '15%'
                                          : '10%',
                                      padding: '5px',
                                    }"
                                    :key="head.valor"
                                  >
                                    {{ head.text }}
                                  </th>
                                </tr>
                              </thead>
                            </template>
                          </v-simple-table>

                          <v-row
                            class="d-flex h-93 align-content-space-between"
                          >
                            <v-col cols="12" class="custom-table-wrapper">
                              <perfect-scrollbar
                                :options="{
                                  wheelSpeed: 0.5,
                                  wheelPropagation: true,
                                }"
                                :style="{
                                  height: altoTablas[itemAlumnos.id_alumno],
                                }"
                              >
                                <v-simple-table>
                                  <template v-slot:default>
                                    <tbody
                                      class="custom-tbody"
                                      v-if="
                                        itemAlumnos.competencias_recuperar
                                          .length != 0
                                      "
                                    >
                                      <tr
                                        v-for="(
                                          competencia, indx
                                        ) in itemAlumnos.competencias_recuperar"
                                        :key="competencia.id_competencia"
                                      >
                                        <td
                                          class="text-center"
                                          :style="{
                                            width: '50%',
                                            padding: '5px',
                                          }"
                                        >
                                          <v-tooltip
                                            v-if="!competencia.isSaved"
                                            top
                                            color="#1b1b1b"
                                          >
                                            <template
                                              v-slot:activator="{ on, attrs }"
                                            >
                                              <v-icon
                                                style="float: left"
                                                v-bind="attrs"
                                                v-on="on"
                                                :class="
                                                  competencia.isSaved
                                                    ? ''
                                                    : 'animate__animated animate__heartBeat animate__infinite'
                                                "
                                                :color="
                                                  competencia.isSaved
                                                    ? '#dfdbdb'
                                                    : '#ffc107'
                                                "
                                                left
                                                x-small
                                                >mdi-checkbox-blank-circle</v-icon
                                              >
                                            </template>
                                            <span>Cambios por guardar</span>
                                          </v-tooltip>
                                          {{ competencia.competencia }}
                                        </td>

                                        <td
                                          :style="{
                                            width: '25%',
                                            padding: '5px',
                                          }"
                                        >
                                          <v-menu
                                            :close-on-content-click="false"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="auto"
                                          >
                                            <template
                                              v-slot:activator="{ on, attrs }"
                                            >
                                              <v-text-field
                                                class="text-caption"
                                                :value="
                                                  dateRangeText(
                                                    competencia.periodo
                                                  )
                                                "
                                                label="Periodo de evaluación"
                                                prepend-icon="mdi-calendar"
                                                readonly
                                                hide-details
                                                v-bind="attrs"
                                                v-on="on"
                                              ></v-text-field>
                                            </template>
                                            <v-date-picker
                                              v-model="competencia.periodo"
                                              no-title
                                              scrollable
                                              :allowed-dates="
                                                allowedDates(
                                                  competencia.periodo
                                                )
                                              "
                                              range
                                              @change="
                                                validarRangoFechaClient(
                                                  $event,
                                                  competencia
                                                )
                                              "
                                            >
                                            </v-date-picker>
                                          </v-menu>
                                        </td>

                                        <td
                                          :style="{
                                            width: '15%',
                                            padding: '5px',
                                          }"
                                        >
                                          <v-select
                                            :disabled="
                                              modifyNotaUpdate(
                                                competencia,
                                                itemAlumnos
                                              )
                                            "
                                            v-model="
                                              competencia.nota_modificada
                                            "
                                            @change="
                                              modifyNota(
                                                $event,
                                                competencia,
                                                itemAlumnos,
                                                'Vacacional'
                                              )
                                            "
                                            hide-details
                                            small-chips
                                            :items="competencia.notas_asignar"
                                            item-value="valor"
                                            item-text="desc"
                                          >
                                            <template v-slot:label>
                                              <p style="font-size: 14px">
                                                Califica
                                              </p>
                                            </template>
                                          </v-select>
                                        </td>

                                        <td
                                          :style="{
                                            width: '10%',
                                            padding: '5px',
                                          }"
                                        >
                                          <v-tooltip top color="#1b1b1b">
                                            <template v-slot:activator="{ on }">
                                              <v-btn
                                                v-on="on"
                                                class="btn_eliminar px-0 mx-0"
                                                fab
                                                x-small
                                                @click="
                                                  removerNuevaNota(
                                                    itemAlumnos,
                                                    competencia,
                                                    indx
                                                  )
                                                "
                                              >
                                                <v-icon small
                                                  >fa-trash-alt</v-icon
                                                >
                                              </v-btn>
                                            </template>
                                            <span>Borrar registro</span>
                                          </v-tooltip>
                                        </td>
                                      </tr>
                                    </tbody>

                                    <tbody v-else>
                                      <tr style="width: 100%">
                                        <th
                                          colspan="4"
                                          class="text-center text-caption"
                                        >
                                          No existe información
                                        </th>
                                      </tr>
                                    </tbody>
                                  </template>
                                </v-simple-table>
                              </perfect-scrollbar>
                            </v-col>
                            <v-col cols="12" class="text-end">
                              <v-row
                                v-if="
                                  itemAlumnos.competencias_recuperar.length != 0
                                "
                              >
                                <v-col cols="12" class="text-center">
                                  <v-scale-transition>
                                    <v-btn
                                      class="animate__animated animate__pulse animate__infinite"
                                      v-if="
                                        validaCompetenciasEvaluadas(itemAlumnos)
                                      "
                                      @click="
                                        EvaluarGenerarHistorico(itemAlumnos)
                                      "
                                      small
                                      color="warning"
                                      >Listo para evaluar
                                      <v-icon small right>fas fa-check </v-icon>
                                    </v-btn>

                                    <v-btn
                                      v-else
                                      @click="
                                        updateCompetenciasRecuperacion(
                                          itemAlumnos
                                        )
                                      "
                                      small
                                      color="primary"
                                      >Guardar cambios
                                      <v-icon small right>fas fa-save</v-icon>
                                    </v-btn>
                                  </v-scale-transition>
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>

      <v-col
        cols="12"
        v-else-if="alumnosVacacional.length == 0 && loading"
        v-for="num in 3"
        :key="num"
        class="mb-0 pb-0"
      >
        <v-skeleton-loader
          class="skeletonRecuperacion"
          max-height="200"
          type="text"
        >
        </v-skeleton-loader>
      </v-col>

      <v-col
        v-else
        class="d-flex justify-center align-center"
        style="background: #f4f4f4"
      >
        No hay resultados <strong class="ml-1"> disponibles</strong>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios, { API_URL } from "@/helpers/axios";
import { mapMutations } from "vuex";
import io from "socket.io-client";
import Sortable from "sortablejs";

export default {
  props: ["tabPosition"],
  data: () => ({
    alumnoValidaTabla: {},
    rutaservidor: API_URL,
    normativas_condicionales_grados: [],
    headerSelectorComp: [
      {
        text: "Competecia",
        value: "competencia",
        class: "secondary black--text",
      },
      {
        text: "Periodos",
        value: "periodos",
        class: "secondary black--text",
      },
      {
        text: "Calificar",
        value: "notas_asignar",
        class: "secondary black--text",
      },
      { text: "Acciones", value: "action", class: "secondary black--text" },
    ],
    itemsDocente: [],
    datoLogin: sessionStorage,
    showDetalle: true,
    panelAlumnosNotas: [],
    niveles: [],
    grados: [],
    secciones: [],
    alumnosVacacional: [],
    alumnosVacacional2: [],
    nivelSelected: -1,
    gradoSelected: -1,
    seccionSelected: -1,
    loading: false,
    altoTablas: {},
    headers: [
      {
        text: "Nombre y Apellido",
        value: "nombres_completos",
        class: "secondary black--text",
      },
      { text: "Nivel", value: "desc_nivel", class: "secondary black--text" },
      { text: "Grado", value: "desc_grado", class: "secondary black--text" },
      {
        text: "Cursos a recuperar",
        value: "desc_curso",
        class: "secondary black--text",
      },
      { text: "Cursos Aprobados", value: "", class: "secondary black--text" }, //POSIBLEMENTE LO RESTRUCTURE
      { text: "Cursos a Cargo", value: "", class: "secondary black--text" }, //POSIBLEMENTE LO RESTRUCTURE
    ],
    menu: false,
  }),
  watch: {
    tabPosition(valor) {
      if (valor == 1) {
        console.log(valor);
        this.loadMain(true);
      }
    },
  },
  mounted() {
    this.loadMain(true);
    this.socket = io(API_URL);
    this.socket.on("periodoRecuperacionActualizado", () => {
      this.loadMain(false);
    });
  },
  beforeDestroy() {
    this.socket.off("periodoRecuperacionActualizado");
    this.socket.disconnect();
  },

  directives: {
    sortable: {
      bind(el, binding, vnode) {
        const options = {
          group: "shared",
          animation: 150,
          handle: ".draggable-button",
          onEnd: function (evt) {
            vnode.context.$emit("sorted", evt);
          },
        };

        const cells = el.querySelectorAll("tr");
        cells.forEach((row) => {
          Sortable.create(row, options);
        });
      },
    },
  },
  methods: {
    ...mapMutations({
      setEnviarMens: "mensajeSis/setEnviarMens",
    }),
    /*______________________________
    │   * Metodo carga inicial      │
     ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    loadMain(flag) {
      this.getAlumnosRecuperados(flag);
      this.listarDocentesRecuperacion();
      this.getNormativasCondicionales();
    },
    /*________________________________________________________
    │   * Método para permitir fechas válidas en el rango     │
     ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    allowedDates(periodo) {
      return (date) => {
        if (periodo != null) {
          if (periodo.length === 0) {
            return true;
          } else if (periodo.length === 1) {
            const startDate = new Date(periodo[0]);
            return new Date(date) >= startDate;
          }
        }
        return true;
      };
    },
    /*___________________________________________________
    │   * Método para arrastrar elementos de la tabla    │
     ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    dragToTable(e) {
      console.log("informacion de e", e);
    },
    /*_________________________________
    │   * Método para abrir normal     │
     ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    openTooltipNorma(datosNorma) {
      if (datosNorma.show_alumno) {
        datosNorma.show_alumno = true;
      } else {
        datosNorma.show_alumno = false;
      }
    },
    /*______________________________________
    │   * Metodo condiciones normativa      │
     ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    obtenerCondicionNormativa(id_alumno, id_grado, id_nivel) {
      let datosAgrupados = {};
      const dataFiltradaNormas = this.normativas_condicionales_grados.filter(
        (el) =>
          el.id_nivel_ck1 == id_nivel &&
          el.id_grado_ck1.some((so) => so.id_grado == id_grado)
      );
      datosAgrupados[id_alumno] = dataFiltradaNormas;

      return datosAgrupados[id_alumno];
    },
    /*_________________________________________
    │   * Metodo string para fecha custom      │
     ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    validaCompetenciasEvaluadas(estudianteData) {
      if (estudianteData.competencias_recuperar.length != 0) {
        // console.log("RAST", estudianteData.competencias_recuperar);

        const validaTabla = estudianteData.isActiveTable;

        const valida = estudianteData.competencias_recuperar.filter(
          (el) => el.nota_modificada == null || el.isSaved == false
        ).length;

        if (valida === 0 && validaTabla) {
          return true;
        } else {
          return false;
        }
      }
    },
    /*_________________________________________
    │   * Metodo string para fecha custom      │
     ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    dateRangeText(data) {
      const dateCurrent = new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);
      return data ? data.join(" ~ ") : [`${dateCurrent} ~ 0000-00-00`];
    },
    /*__________________________________________________________________________________________________
    │   * Metodo guardar y actualizar competencias selecionar por docente para posterior evaluación     │
     ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    async updateCompetenciasRecuperacion(datosEstudianteActual) {
      for (let e of datosEstudianteActual.competencias_recuperar) {
        e.isSaved = true;
      }

      datosEstudianteActual.isActiveTable = true;

      try {
        const { data } = await axios.put(
          `/cierreanio/recuperacion/updateAlumnosRecuperacionCompetencias/`,
          datosEstudianteActual
        );

        if (data) {
          this.setEnviarMens({
            tipo: "S",
            mensaje: `Competencias asignadas para evaluar`,
            tiempo: 3000,
          });
        }
        // this.itemsDocente = data;
      } catch (error) {
        console.error(error);
      }
    },
    /*_________________________________________
    │   * Metodo string para fecha custom      │
     ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    async listarCompetenciasRecuperar(id) {
      try {
        const { data } = await axios.get(
          `/cierreanio/recuperacion/listarCompetenciasRecuperar/${id}`
        );

        return data.competencias_recuperar;
      } catch (error) {
        console.error(error);
      }
    },
    /*___________________________________________________________________
    │   * Metodo evaluar y generar historico de notas recuperativas      │
     ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    async EvaluarGenerarHistorico(datosEstudianteActual) {
      datosEstudianteActual.estado_alumno = false;

      const datosCompararCurrent = datosEstudianteActual.competencias_recuperar;
      const datosCompararDB = await this.listarCompetenciasRecuperar(
        datosEstudianteActual.id
      );

      let sonIguales =
        JSON.stringify(datosCompararDB.sort((a, b) => a.id - b.id)) ===
        JSON.stringify(datosCompararCurrent.sort((a, b) => a.id - b.id));

      if (!sonIguales) {
        this.setEnviarMens({
          tipo: "W",
          mensaje: `Por favor guardar todos los cambios para Evaluar`,
          tiempo: 1000,
        });

        return;
      }

      try {
        // eslint-disable-next-line no-unused-vars
        const { data } = await axios.post(
          `/cierreanio/recuperacion/updateAlumnosGenerarHistorico/`,
          datosEstudianteActual
        );
        // if (data) {
        this.setEnviarMens({
          tipo: "S",
          mensaje: `Estudiante fue evaluado en el periodo de recuperación`,
          tiempo: 3000,
        });
        // }
        // this.itemsDocente = data;
      } catch (error) {
        console.error(error);
      }
    },
    /*___________________________________________________________
    │   * Metodo validar selecion de competencias repetidas      │
     ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    validaSeleccion(datosFilter, competencias, index) {
      if (
        !datosFilter ||
        datosFilter.length === 0 ||
        !competencias[index - 1] ||
        competencias[index - 1].ID_COMPETENCIA == undefined
      ) {
        return false;
      }

      return datosFilter.some(
        (e) => e.id_competencia == competencias[index - 1].ID_COMPETENCIA
      );
    },
    /*________________________________________________________________
    │   * Metodo validar rangos de fecha a nivel cliente frontend     │
     ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    validarRangoFechaClient(valor_nuevo, filas_actual) {
      filas_actual.isSaved = false;
      const today = new Date().toISOString().substr(0, 10);
      if (valor_nuevo.includes(today)) {
        filas_actual.estado = true;
      } else {
        filas_actual.estado = false;
      }
    },
    /*___________________________________________________
    │   * Metodo modificar notas alumnos recuperados     │
     ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    async modifyNota(valor_nuevo, filas_actual, estudianteData, modulo) {
      filas_actual.isSaved = false;

      if (valor_nuevo != null && filas_actual != null) {
        const areas = estudianteData.areas_estudiante;
        areas
          .filter((e) => e.id_area_adm == filas_actual.id_area_adm)[0]
          .nivel_logro_competencias_area.filter(
            (e) => e.ID_COMPETENCIA == filas_actual.id_competencia
          )[0].NIVEL_LOGRO_COMPETENCIA = valor_nuevo;
      }

      try {
        let data = {
          id_ano_lectivo_actual: parseInt(this.datoLogin.id_ano_lectivo),
          id_colegio: parseInt(this.datoLogin.id_colegio),
          modulo: modulo,
          estudiantes: [estudianteData],
        };

        // const response = respuesta;
        const response = await axios.post(
          "/cierreanio/cierreanioituacionestudiante/actualizarAlumnosRecuperacion",
          data
        );

        if (response.data.MSG) {
          const condicionAreaNueva =
            response.data.DATOS[0].areas_estudiante.reduce(
              (acc, condicionNueva) => {
                acc[condicionNueva.id_area_adm] = condicionNueva;
                return acc;
              },
              {}
            );

          estudianteData.areas_estudiante = estudianteData.areas_estudiante.map(
            (condicionActual) => {
              return condicionAreaNueva[condicionActual.id_area_adm]
                ? {
                    ...condicionActual,
                    ...condicionAreaNueva[condicionActual.id_area_adm],
                  }
                : condicionActual;
            }
          );

          estudianteData.criterio_estado_final =
            response.data.DATOS[0].criterio_estado_final;
        } else {
          this.setEnviarMens({
            tipo: "W",
            mensaje: `Algo salió mal, revisa la configuracion previa`,
            tiempo: 3000,
          });
        }
      } catch (error) {
        console.log(error);
      }
      // finally {
      //   this.getAlumnosRecuperados(false);
      // }
    },
    /*_________________________________________
    │   * Metodo string para fecha custom      │
     ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    modifyNotaUpdate(filas_actual, estudianteData) {
      // eslint-disable-next-line no-unused-vars
      const areas = estudianteData.areas_estudiante;
      return !filas_actual.estado;
    },
    /*_____________________________________
    │   * Metodo añadir notas a editar     │
     ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    async addRowNotaComp(area, estudiante, data) {
      const dataTable = this.$refs["dataTable" + estudiante.id_alumno][0].$el;
      const tableHeight = dataTable.clientHeight;

      this.$set(
        this.altoTablas,
        estudiante.id_alumno,
        `${tableHeight - 100}px`
      );
      if (
        !estudiante.competencias_recuperar.some(
          (objeto) => objeto.competencia == data.DESCRIPCION_COMPETENCIA
        )
      ) {
        // const buttonRect = event.target.getBoundingClientRect();
        // const tableRect = this.$refs.leftTable[0].$el.getBoundingClientRect()
        estudiante.competencias_recuperar.push({
          competencia: data.DESCRIPCION_COMPETENCIA,
          id_competencia: data.ID_COMPETENCIA,
          id_area_adm: data.ID_AREA_ADM,
          dec_area_adm: area,
          nota_actual: data.NIVEL_LOGRO_COMPETENCIA,
          nota_modificada: null,
          nota_cargo_modificada: null,
          periodo: null,
          notas_asignar: [
            { valor: 4, desc: "AD" },
            { valor: 3, desc: "A" },
            { valor: 2, desc: "B" },
            { valor: 1, desc: "C" },
          ],
          estado: false,
          isSaved: false,
          isSavedCargo: false,
        });
      } else {
        this.setEnviarMens({
          tipo: "W",
          mensaje: "Ya estableciste esta competencias en la lista",
          tiempo: 1000,
        });
      }
    },
    /*________________________________________________
    │   * Metodo eliminar competencia seleccionada    │
     ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    removerNuevaNota(estudianteData, filas_actual, index) {
      estudianteData.isActiveTable = false;

      console.log(estudianteData);

      const resetValue = filas_actual.nota_actual;
      this.modifyNota(resetValue, filas_actual, estudianteData, "Vacacional");
      estudianteData.competencias_recuperar.splice(index, 1);
    },
    /*_________________________________________________________________
    │   * Metodo obtener el titulo de la competencia en el tooltip     │
     ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    obtenerDesComp(data) {
      if (data != undefined) {
        return data.DESCRIPCION_COMPETENCIA;
      }
    },
    /*__________________________________________________________________
    │   * Metodo para listar los alumnos con estado de recuperacion     │ 
     ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    async getAlumnosRecuperados(flag) {
      const id_colegio = this.datoLogin.id_colegio;
      this.loading = flag;

      const { data } = await axios.get(
        `/cierreanio/recuperacion/listarAlumnosRecuperacion/${id_colegio}`
      );

      const agrupadosPorGrado = Object.values(
        data.reduce((grupo, estudiante) => {
          const { id_grado_adm, desc_grado, desc_nivel } = estudiante;
          grupo[id_grado_adm] = grupo[id_grado_adm]
            ? grupo[id_grado_adm]
            : { id_grado_adm, desc_nivel, desc_grado, grados_estudiante: [] };
          estudiante.competencias_recuperar =
            estudiante.competencias_recuperar == null
              ? []
              : estudiante.competencias_recuperar;

          estudiante.isActiveTable = true;
          grupo[id_grado_adm].grados_estudiante.push(estudiante);
          return grupo;
        }, {})
      );

      this.alumnosVacacional = agrupadosPorGrado;

      this.alumnosVacacional2 = data;
      this.loading = false;
    },
    /*_____________________________________________________________________
    │   * Método para obtener los estilos deacuerdo a la nota obtenido     │ 
     ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    obtenerEstilosParaNotas(notaNum) {
      switch (notaNum) {
        case 4:
          return "background-color:#4caf50; color: white; font-weight: bolder;";
        case 3:
          return "background-color:#4caf50; color: white; font-weight: bolder;";
        case 2:
          return "background-color:#ffbc00; color: white; font-weight: bolder;";
        case 1:
          return "background-color:#e53935; color: white; font-weight: bolder;";
        default:
          return "";
      }
    },
    /*_____________________________________________________________________
    │   * Método para obtener los estilos deacuerdo a la nota obtenido     │ 
     ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    desabilitarBotonesNotas(notaNum) {
      switch (notaNum) {
        case 4:
          return true;
        case 3:
          return true;
        case 2:
          return false;
        case 1:
          return false;
        default:
          return "";
      }
    },
    /*________________________________________________________________
    │   * Método para obtener el valor o nota de las competencias     │ 
     ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    obtenerNotaComp(notasrecuperadas, competencias, index) {
      competencias.forEach((e) => {
        let datosRec = notasrecuperadas.filter(
          (el) => el.id_competencia == e.ID_COMPETENCIA
        );
        if (datosRec.length > 0) {
          if (datosRec[0].nota_modificada != null) {
            e.NIVEL_LOGRO_COMPETENCIA = datosRec[0].nota_modificada;
          }
        }
      });

      return competencias[index - 1]
        ? Math.round(competencias[index - 1].NIVEL_LOGRO_COMPETENCIA)
        : null;
    },
    /*___________________________________________________________
    │   * Método para convertir nota numerica a nota literal     │ 
     ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    convertirNumAliteral(notaNum) {
      switch (notaNum) {
        case 4:
          return "AD";
        case 3:
          return "A";
        case 2:
          return "B";
        case 1:
          return "C";
        default:
          return "";
      }
    },
    /*___________________________________________________________________
    │   * Método contabilizar las notas de cada competencia por tipo     │ 
     ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    conteoTipoNotasComp(valorArray, caso) {
      switch (caso) {
        case "AD+A":
          return valorArray.filter((e) =>
            [3, 4].includes(Math.round(e.NIVEL_LOGRO_COMPETENCIA))
          ).length;

        case "B":
          return valorArray.filter((e) =>
            [2].includes(Math.round(e.NIVEL_LOGRO_COMPETENCIA))
          ).length;

        case "C":
          return valorArray.filter((e) =>
            [1].includes(Math.round(e.NIVEL_LOGRO_COMPETENCIA))
          ).length;

        default:
          return 0;
      }
    },
    /*___________________________________________________
    │   * Método obtener docentes para recuperacion      │ 
     ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    async listarDocentesRecuperacion() {
      const id_colegio = Number(this.datoLogin.id_colegio);

      try {
        const { data } = await axios.get(
          `/cierreanio/recuperacion/listarDocenteAsignadosRecuperacion/${id_colegio}`
        );
        this.itemsDocente = data;
      } catch (error) {
        console.error(error);
      }
    },
    /*___________________________________________________________
    │   * Método obtener todas las normativas y condiciones      │ 
     ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯*/
    async getNormativasCondicionales() {
      try {
        const { data } = await axios.get(
          "/cierreanio/cierreanioituacionestudiante/get-normativas-condicional-grado"
        );

        this.getAlumnosRecuperados;

        if (data.length != 0) {
          this.normativas_condicionales_grados = data.map((el) => {
            return { ...el, show_alumno: false };
          });
        }
      } catch (error) {
        this.setEnviarMens({
          tipo: "E",
          message:
            "Error al traer las condicionales de las normativas ministeriales.",
        });
      }
    },
  },
};
</script>
<style scoped>
.enunciadoAlert {
  font-size: 14px;
}
thead th,
tbody td {
  border: thin solid rgba(0, 0, 0, 0.12);
}
.text-center {
  text-align: center;
}
.customheight {
  line-height: 35px;
}
.customrow {
  display: flex;
  align-items: center;
}
td.text-center.tdrecuperacion {
  padding: 4px 2px;
}
</style>
<style>
.skeletonRecuperacion > .v-skeleton-loader__text {
  height: 70px;
}

.expaco > .v-expansion-panel-content__wrap {
  padding: 0px 0px 10px 0px;
}

.custom-table-wrapper > .ps__rail-y {
  opacity: 1 !important;
}

.classMenu {
  background: white !important;
  width: 50%;
  margin-top: 7px;
}
</style>
